export const isEmptyString = (str?: null | string) => !str?.trim()?.length;

/**
 * Splits a string by a regular expression, returning an array of matched and non-matched segments.
 *
 * @param text The input string to process.
 * @param regex The regular expression to split the string with. The function will enforce the global ('g') flag.
 * @returns An array of objects, each representing either a non-matched text segment or a matched segment.
 */
export const splitStringByRegExp = (
  text: string,
  regex: RegExp
): (
  | {
      match: RegExpMatchArray;
      type: "match";
    }
  | {
      text: string;
      type: "text";
    }
)[] => {
  const finalRegex = regex.flags.includes("g")
    ? regex
    : new RegExp(regex.source, `${regex.flags}g`);

  let lastIndex = 0;

  const result: ReturnType<typeof splitStringByRegExp> = [];

  for (const match of text.matchAll(finalRegex)) {
    const matchIndex = match.index ?? 0;

    if (matchIndex > lastIndex) {
      result.push({
        text: text.substring(lastIndex, matchIndex),
        type: "text",
      });
    }

    result.push({
      match: match,
      type: "match",
    });

    lastIndex = matchIndex + match[0].length;
  }

  // Capture any remaining non-matched text at the end of the string.
  if (lastIndex < text.length) {
    result.push({
      text: text.substring(lastIndex),
      type: "text",
    });
  }

  return result;
};
